"use client";

import {
  Boxes,
  Layers,
  Plane,
  ShieldCheck,
  Star,
  type LucideIcon,
} from "lucide-react";
import { useTranslations } from "next-intl";

import type { HomeHeroIconKey, HomeHeroStat } from "@/types/home-messages";

const NAVY = "#1e3a5f";
const ORANGE = "#FF6B35";

const iconMap: Record<HomeHeroIconKey, LucideIcon> = {
  plane: Plane,
  users: Boxes,
  briefcase: Boxes,
  user: Boxes,
  clipboard: Boxes,
  trending: Boxes,
  shield: ShieldCheck,
  boxes: Boxes,
  graduation: Boxes,
  star: Star,
  layers: Layers,
};

export default function HomeMetricsBar() {
  const t = useTranslations("Hero");
  const stats = (t.raw("stats") as HomeHeroStat[]) ?? [];

  if (stats.length === 0) {
    return null;
  }

  return (
    <section className="bg-white pb-6 pt-2" data-component-instance="homeMetricsBar">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
          <div className="grid grid-cols-2 divide-x divide-gray-200 md:grid-cols-4">
            {stats.map((stat) => {
              const StatIcon = iconMap[stat.icon] ?? Plane;
              return (
                <div key={stat.label} className="flex items-center gap-3 px-5 py-4">
                  <div
                    className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg"
                    style={{ backgroundColor: `${ORANGE}15` }}
                  >
                    <StatIcon className="h-4 w-4" style={{ color: ORANGE }} aria-hidden />
                  </div>
                  <div className="min-w-0">
                    <div className="text-[14px] font-bold" style={{ color: NAVY }}>
                      {stat.value}
                    </div>
                    <div className="truncate text-[11px] text-gray-600">{stat.label}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
